import { Component, Input } from '@angular/core';
import { NavItem } from '@app/admin/models';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
    @Input({ required: true }) menu!: NavItem[];
}
